import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://stoplight.io/mocks/maxplank/foodclub/56512039",
  }),
  endpoints: () => ({}),
});
